const formTools = {
    reloadPage: function () {
        setTimeout(function () {
            location.reload();
        }, 2000)
    },

    isValidEmail: function (email) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(email);
    },

    isValidMotoModel: function (motoModel) {
        const regex = /^[a-zA-Z0-9]+$/;
        return regex.test(motoModel);
    },

    loaderForm: function (form, status, classBlock = false, timeout = 0) {
        const parent = form.closest('div');
        if (typeof parent.attr('data-not_loader') == 'undefined' || parent.attr('data-not_loader') != 'false') {
            if (status === 'start') {
                parent.append(`<div class="loader_form js__loader_form ${classBlock}"><span class="loader"></span></div>`);
            } else {
                parent.find('.js__loader_form').remove();
                this.toggleButton('unDisabled', form);
            }
        }
    },

    toggleButton: function (toggle, form = '') {
        const elements = form == '' ? $('.js__login_system') : form.find('.js__send_btn');

        if (toggle == 'disabled') {
            elements.addClass('disabled').prop('disabled', true);
        } else if (toggle == 'unDisabled') {
            elements.removeClass('disabled').prop('disabled', false);
            $('.js__login_system').removeClass('disabled').prop('disabled', false);
        }
    },


    clearForm: function (form) {
        form.find('input[type="text"], input[type="password"], textarea').val('');
    },

    errorRequest: function (form, errorName) {
        const requestError = form.find(`.js__error_request[data-error=${errorName}]`);
        const wrapper = requestError.closest('.input_wrapper');

        requestError.slideDown('slow');
        wrapper.addClass('error_input');
    },

    showError: function (wrapper, selector) {
        wrapper.addClass('error_input');
        wrapper.find(selector).slideDown('slow');
    },

    clearErrors: function (wrapper) {
        wrapper.removeClass('error_input');
        wrapper.find('.error_required').hide();
    },

    clearAllErrors: function () {
        $('.input_wrapper').removeClass('error_input');
        $('.error_required').hide();
    },

    sortRequestForm: function (name, objectData, form = '') {
        const additionalSettings = {
            "form": form,
        };

        switch (name) {
            case 'feedback':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'buy':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'offer':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'service':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'test_ride':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'winter_storage':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'sell':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'check_tech_akcii':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'request_product_availability':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'register_ride':
                this.postSend(objectData, additionalSettings, name);
                break;
            case 'verification':
                this.postVerification(objectData, additionalSettings, name);
                break;
        }
    },

    postSend: function (objectData, additionalSettings, name) {
        $.post(request.postSend, objectData, function (data) {
            if (data.status) {
                formTools.loaderForm(additionalSettings['form'], 'stop', false, 400);
            }

            if (data.status == 'success') {
                window.location.href = '/stranica-blagodarnosti?flag=form&type=' + name;
            }
        });
    },

    postVerification: function (objectData, additionalSettings, name) {
        $.post(request.postVerification, objectData, function (data) {
            if (data.status) {
                formTools.loaderForm(additionalSettings['form'], 'stop', false, 400);
            }

            if (data.status == 'success') {
                $('.js__hide_verification').hide();
                $('.js__verification_code').show().addClass('required')
                    .find('input').attr('data-string', data.data);
                $('.register_ride_holder').attr('data-form', 'register_ride');
            }

            if (data.status == 'error') {
                formTools.showError($('.js__phone_block'), '.js__not_valid_phone_error');
            }
        });
    },

    uploadFile: function (formdata, form) {
        $.ajax({
            url: request.uploadFile,
            type: 'post',
            data: formdata,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function (data) {
                if (data.status == 'success') {
                    formTools.updateInfoDoc(data.data, form);
                }
            }
        });
    },

    updateInfoDoc: function (data, form) {
        $('.js__modal_window[data-modal=upload_file]').remove();
        let count = Number(form.find('.js__count_file').attr('data-count'));

        for (let item in data) {
            form.find('.js__append_file').append(`<li>
            <a href="${data[item].url}">${data[item].name}</a>
            <button type="button" data-name="${data[item].file_name}" class="js__delete_file">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
            </svg>
            </button>
            <input type=hidden value="${data[item].file_name}" name="file" data-count="${count}">
            </li>`);

            count++;
        }

        form.find('.js__count_file').attr('data-count', count);
    },

    deleteFile: function (name, wrapper) {
        $.post(request.deleteFile, {
            name: name,
        }, function (data) {
            if (data.status == 'success') {
                wrapper.remove();
            }
        });
    }
};

$(document).ready(function () {
    $(document).on('input', '.input_input', function () {
        const wrapper = $(this).closest('.input_wrapper');
        formTools.clearErrors(wrapper);
    });

    $(document).on('change', 'input[name=privacy_policy], input[name=is_familiar], input[name=is_license]', function () {
        const wrapper = $(this).closest('.input_wrapper');
        formTools.clearErrors(wrapper);
    });

    $(document).on('click', '.js__delete_file', function () {
        const btn = $(this);
        const wrapper = btn.closest('li');
        const name = btn.attr('data-name');

        formTools.deleteFile(name, wrapper);
    })

    $(document).on('change', '#file', function () {
        var fd = new FormData();
        var files = $('#file')[0].files;
        var form = $(this).closest('form');

        for (var i = 0; i < files.length; i++) {
            fd.append('files[]', files[i]);
        }

        fd.append('lang', lang);
        formTools.uploadFile(fd, form);
    });

    $(document).on('submit', '.js__valid_form', function (e) {
        e.preventDefault();

        const form = $(this);
        const requestName = form.attr('data-form');
        const objectData = {
            'lang': lang,
        };

        if (form.find('#file').length > 0) {
            objectData.files_upload = {};
        }

        formTools.toggleButton('disabled', form);

        formTools.clearAllErrors();
        let error = 0;
        let codeVerif = '';

        let classBlock = false;

        if (typeof form.attr('data-type_loader') !== 'undefined') {
            classBlock = form.attr('data-type_loader');
        }

        form.find('input, textarea').each(function () {
            const input = $(this);
            const name = input.attr('name');
            const wrapper = input.closest('.input_wrapper');
            const type = input.attr('type');
            let value = input.val().trim();

            if (name) {
                if (wrapper.hasClass('required')) {
                    if (value === '') {
                        formTools.showError(wrapper, '.js__main_error');
                        error++;
                    } else if (name === 'email' && !formTools.isValidEmail(value)) {
                        formTools.showError(wrapper, '.js__not_valid_email_error');
                        error++;
                    } else if (name === 'moto_model' && !formTools.isValidMotoModel(value)) {
                        formTools.showError(wrapper, '.js__not_valid_moto_model');
                        error++;
                    } else if (name === 'phone') {
                        value = value.replace(/\D/g, '');
                        if (value === '') {
                            formTools.showError(wrapper, '.js__main_error');
                            error++;
                        }
                    } else if (name == 'verification_code') {
                        const string = atob($(this).attr('data-string'));

                        if (string != value) {
                            formTools.showError(wrapper, '.js__not_valid_code');
                            error++;
                        }
                    }
                }

                if (type == 'radio') {
                    if (input.is(':checked')) {
                        objectData[name] = value;
                    }
                } else if (name == 'file') {
                    objectData.files_upload[input.attr('data-count')] = value;
                } else if (name == 'code_verif') {
                    codeVerif += value;
                } else {
                    objectData[name] = value;
                }

                if (['privacy_policy', 'is_familiar', 'is_license'].includes(name)) {
                    if (!input.is(':checked')) {
                        formTools.showError(wrapper, '.js__main_error');
                        error++;
                    }
                }
            }
        });

        if (codeVerif != '') {
            objectData['confirmation_code'] = codeVerif;
        }

        if (error === 0) {
            formTools.loaderForm(form, 'start', classBlock);
            formTools.sortRequestForm(requestName, objectData, form);
        } else {
            formTools.toggleButton('unDisabled', form);
        }
    });
});